/* eslint-disable */
require("es6-promise").polyfill();
import queryString from "query-string";
import $ from "jquery";
import fetchResults from "./search/fetchResults";

export default class CheckboxFilters {
    constructor(checkboxesSelector, form, searchContainer, documentActiveClass)
    {
        this.checkboxes = document.querySelectorAll(checkboxesSelector);
        this.checkboxValue = [].slice.call(this.checkboxes);
        this.form = document.querySelector(form);
        this.searchContainer = document.querySelector(searchContainer);
        this.documentActiveClass = documentActiveClass;

        this.bindEventHandlers();
    }

    bindEventHandlers()
    {
        this.checkboxValue.forEach(el => {

            // Set initial state based on HTML attribute
            if (el.checked) {
                $(el).addClass(this.documentActiveClass);
            }

      $(el).keypress(event => {
        if (event.which == 13 || event.which == 32) {
          event.preventDefault();
          if ($(el).is(":focus")) {
            this.CheckboxEvent(checkbox, this.searchContainer, el);
            this.SetupSubtopics(el, checkbox);
          }
        }
      });

            // Set up handler for Mouse clicks and Spacebar key
            el.addEventListener("change", () => {
                this.handleFilterToggle(el);
            });
        });
    }

  /**
   * Filter toggle
   *
   * @param {HTMLElement} el The checkbox element
   */
    handleFilterToggle(el)
    {
        if (el.checked) {
            $(el).addClass(this.documentActiveClass);
        } else {
            $(el).removeClass(this.documentActiveClass);
        }

        this.CheckboxEvent(el, this.searchContainer, el);
        this.SetupSubtopics(el, el);
    }

    CheckboxEvent(checkbox, searchContainer, el)
    {
        const paramName = el.getAttribute("name");
        const paramValue = el.value;

        if ($(el).hasClass(this.documentActiveClass)) {
            $(el).attr("aria-checked", "true");
        } else {
            $(el).attr("aria-checked", "false");
        }

        // Only handle updating the query string and fetching results
        // via AJAX if at tablet or desktop
        if ($(window).outerWidth() > 767) {
            let form = $(el).closest("form");
            let data = form.serialize();

            let params = queryString.parse(location.search, {
                arrayFormat: "bracket",
                encode: false
            });

            // Set parameter based on the final checked state
            if (el.checked) {
                params[paramName] = paramValue;
            } else {
                params[paramName] = undefined;
            }

            // If the `start` param exists, remove this so we can reset
            // the pagination back to 0 on our newly filtered results
            if (params["start"]) {
                params["start"] = undefined;
            }

            params = queryString.stringify(params, {
                arrayFormat: "bracket",
                encode: false
            });

            const url = `${location.origin}${location.pathname}?${params}`;
            window.history.pushState({}, "filter", url);

            // If `#search-page-filters` exists, set the url to be the form action (likewise for doc search form)
            let fetchURL = $("#search-page-filters").length || $(".document-search-form").length ? form.attr("action") : url;
            fetchResults(fetchURL, data, this.searchContainer, el);
        }
    }

    SetupSubtopics(el, checkbox)
    {
        if ($(el).closest("[data-subtopics-link]").length) {
            let subtopicLink = $(el)
            .closest("[data-subtopics-link]")
            .data("subtopics-link");

            let form = $(el).closest("form");
            let data = form.serialize();

            $.ajax({
                url: subtopicLink,
                data: data
            })
            .done(response => {
                // Set the subtopics field html on success
                $(el).closest('form').find('.field--subtopics').html(response);

                const documentFilter = new CheckboxFilters(
                    ".field--subtopics .category-checkbox",
                    ".document-search-form",
                    "[data-inject='search-results']",
                    "checkbox-toggle--active"
                );
            })
            .fail(response => {
                console.warn(response);
            });
        }
    }
}
/* eslint-enable */
